import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LearningProgressEntity } from '@/entities/learning-progress.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class LearningProgressService
  extends CreateService<LearningProgressEntity>('learning-progress')
  implements CRUDServiceInterface<LearningProgressEntity>
{
  async getMany(): Promise<LearningProgressEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }

  async getLessonProgress(
    lessonId: string | number,
  ): Promise<LearningProgressEntity> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .filter('lessonId', '$eq', String(lessonId))
      .getMany();
    return items[0];
  }

  async readPage(lessonId: number, page: number) {
    const response = await APIBuilder.axios.post<LearningProgressEntity>(
      `/${this.store}/read`,
      {
        lessonId,
        page,
      },
    );
    return response.data;
  }
}
